var commerce = {};
module['exports'] = commerce;
commerce.color = require("./color");
commerce.department = require("./department");
commerce.product_name = require("./product_name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/commerce/index.js
// module id = 1468
// module chunks = 1